<template>
  <section>
    <policy-filter :filter="this.filter" @changeFilter="changeFilter"/>
    <div v-if="loadedFilter" class="rounded border bg-white h-200px info-panel custom-table">
      <loader-full />
    </div>
    <template v-else>
      <policy-local
          v-if="policies && policies.hasOwnProperty('data')  && policies.data"
          :policies="policies"
          @reloaded="reloadPolices"
          @open="openPolicyModal"/>
      <policies-by-iin
          v-if="policies && policies.hasOwnProperty('byIin') && policies.byIin && policies.byIin.length"
          :policies="policies.byIin"
          @getGlobal="getGlobal"/>
      <policy-modal
          v-if="policyItem"
          :policy="policyItem"
          @rescind="rescind"
          @dissolution="dissolution"
      />
      <operator-error-modal
          :id="operatorErrorModalData.id"
          @reload="getPolicies"
      />
      <termination-modal
          v-if="dissolutionModalData.hash"
          :resident="dissolutionModalData.resident"
          :global="dissolutionModalData.global"
          :person="dissolutionModalData.person"
          :hash="dissolutionModalData.hash"
          :ip="dissolutionModalData.ip"
          :signatories="this.signatories"
          @reload="getPolicies"
      />
    </template>
  </section>
</template>

<script>
import OperatorErrorModal   from "@/components/Modals/Policy/OperatorErrorModal.vue";
import TerminationModal     from "@/components/Modals/Policy/TerminationModal.vue";
import PoliciesByIin        from '@/components/Policy/PoliciesByIin';
import PolicyFilter         from '@/components/Policy/PolicyFilter'
import PolicyLocal          from '@/components/Policy/PoliciesLocal'
import PolicyModal          from '@/components/Modals/Policy/PolicyModal'
import LoaderFull           from '@/components/Main/LoaderFull'
// Library
import axios from 'axios'

export default {
  name: 'Policies',
  components: {TerminationModal, OperatorErrorModal, PoliciesByIin, PolicyFilter, PolicyLocal, PolicyModal, LoaderFull,
  },
  data() {
    return {
      loadedFilter: false,
      policyItem:   null,
      policies:     null,
      filter: {
        isGlobal: false,
        isShort: true,
        created:  '',
        manager:  '',
        creator:  '',
        global:   '',
        status:   '',
        one_c:    '',
        start:    '',
        end:      '',
        iin:      '',
        apc:      this.$user.apc ?? ''
      },
      verifyBmgData: {
        global:   null,
        isGlobal: false,
      },
      operatorErrorModalData: {
        id:       null,
      },
      dissolutionModalData: {
        resident: null,
        global:   null,
        person:   null,
        hash:     null,
        ip:       null
      }
    }
  },
  mounted() {
    this.$store.dispatch('signatoriesRequest')
    this.getIp()
        .then(res => {this.dissolutionModalData.ip = res.data.ip})
        .catch(err => {confirm(`Ошибка загрузки страницы`) ? location.reload() : location.reload()});

    this.getPolicies().then(() => {
      if (!this.$route?.query?.draft || !this.policies?.data) return
      const draft = this.$route.query.draft
      const policy = this.policies.data.find(p => p.draft_ulid == draft)
      if (policy) {
        this.openPolicyModal(policy)
      } else {
        this.$notifyError({ message: 'Ошибка при открытии модального окна' })
      }
    })
  },
  computed: {
    signatories() { return this.$store.getters.getSignatories },
  },
  methods: {
    async getIp() {
      return await axios.get('api/get-ip')
    },
    getPolicies(page = 1) {
      this.loadedFilter = true
      this.dataKey      = 0
      if (!this.filter.start && this.filter.end) this.filter.start = this.filter.end;
      if (!this.filter.end && this.filter.start) this.filter.end = this.filter.start;
      const headers     = {headers: {}, params: this.filter}
      return axios.get('/api/policy/all?page=' + page, headers)
          .then(res  => {
            if ('message' in res.data) {
              this.$notifyWarning({ message: res.data.message });
              this.policies = null
            } else {
              this.policies = res.data
              if (res.data.hasOwnProperty('byGlobal') && res.data.byGlobal) {
                this.openPolicyModal(res.data.byGlobal)
              }
            }
          })
          .catch(err => { console.log(err) })
          .finally(() => {if (this.loadedFilter) this.loadedFilter = false})
    },
    changeFilter(val) {
      val.hasOwnProperty('global') ? this.filter = val : this.loadedFilter = val
      this.getPolicies()
    },
    reloadPolices(val) {
      if (val) this.getPolicies(val)
    },
    openPolicyModal(val) {
      this.policyItem = val
      setTimeout(() => {new bootstrap.Modal('#policiesModal', {}).show()}, 10)
    },
    loaded(val) {
      if (val) {
        this.loadedFilter = !this.loadedFilter
      }
    },
    getGlobal(global) {
      this.loadedFilter = true
      const headers = {headers: {}, params: {global:global, isGlobal:'true'}}
      axios.get('/api/policy/all?page=1', headers)
          .then(res  => {
            if (res.data.hasOwnProperty('byGlobal')) {
              this.openPolicyModal(res.data.byGlobal)
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {this.loadedFilter = false})
    },
    policiesModalHidden() {
      const myModalEl = document.getElementById('policiesModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    rescind(data) {
      this.operatorErrorModalData.id       = data.id
      this.policiesModalHidden()
      setTimeout(() => {new bootstrap.Modal('#operatorErrorModal', {}).show()}, 150)
    },
    dissolution(data) {
      this.dissolutionModalData.resident = data.resident
      this.dissolutionModalData.global   = data.global_id
      this.dissolutionModalData.person   = data.person
      this.dissolutionModalData.hash     = data.hash
      this.policiesModalHidden()
      setTimeout(() => {new bootstrap.Modal('#terminationModal', {}).show()}, 150)
    },
  }
}
</script>

<style scoped>
  .bg-success {
    background-color: #50cd89 !important;
  }
</style>